import { useEffect, useState } from "react";
import { KeyRound, Coins } from "lucide-react";
import { useSession } from "@/context/SessionContext";
import { vaultSecurityApi } from "@/api/vaultSecurity";

// STAGE 6 · PHASE 3 — Trust Cue.
// Shows whether the current overlay-removal task runs on the user's OWN Fal key
// (BYOK / founder) or burns platform coins — read from the active tier config.

const FAL_NAMES = ["FAL_AI_API_KEY", "FAL_KEY", "FAL_API_KEY", "FALAI"];
const COIN_COST = 5;

export default function KeyModePill({ className = "" }) {
  const { user } = useSession();
  const [personal, setPersonal] = useState(false);
  const isFounder = user?.role === "founder" || (user?.handle || "").toLowerCase() === "johnnywalker";

  useEffect(() => {
    if (isFounder) { setPersonal(true); return; }
    let live = true;
    vaultSecurityApi.byokRegistry()
      .then((keys) => { if (live) setPersonal((keys || []).some((k) => k.set && FAL_NAMES.includes(k.name))); })
      .catch(() => {});
    return () => { live = false; };
  }, [isFounder]);

  if (personal) {
    return (
      <div data-testid="key-mode-pill" data-mode="personal"
        className={`flex items-center gap-1.5 rounded-full border-2 border-emerald-400/50 bg-emerald-500/10 px-3 py-1.5 ${className}`}>
        <KeyRound size={12} className="text-emerald-300" />
        <span className="font-mono text-[9px] font-black uppercase tracking-[0.14em] text-emerald-300">
          {isFounder ? "Running on Founder Key ✓" : "Running on your Personal Key ✓"}
        </span>
      </div>
    );
  }
  return (
    <div data-testid="key-mode-pill" data-mode="platform"
      className={`flex items-center gap-1.5 rounded-full border-2 border-gold/50 bg-gold/10 px-3 py-1.5 ${className}`}>
      <Coins size={12} className="text-gold" />
      <span className="font-mono text-[9px] font-black uppercase tracking-[0.14em] text-gold">
        Using Platform Credits [{COIN_COST}]
      </span>
    </div>
  );
}
